import React, { useState, useEffect } from 'react';
import { FormGroup, Form, Dropdown } from 'semantic';
import { useTranslation } from 'react-i18next';
import {
  PaymentOption,
  PaymentOptionValues,
} from 'subdomains/cpo/types/charging-policy';
import { DropdownOption } from 'subdomains/cpo/types/form';
import CardStyleRadioButton from 'components/form-fields/CardStyleRadioButton';
import { getPaymentOptionLabel } from './utils';

type Props = {
  values: PaymentOption[];
  onChange?: (values: string[]) => void;
};

const PaymentOptionSelection: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(!props.values?.length);
  const [selectedMethods, setSelectedMethods] = useState<string[]>(
    props.values
  );

  useEffect(() => {
    if (isAllSelected) {
      props.onChange?.([]);
    } else if (selectedMethods.length > 0) {
      props.onChange?.(selectedMethods);
    }
  }, [isAllSelected, selectedMethods]);

  const handleModeChange = (isAll: boolean) => {
    if (isAll != isAllSelected) {
      setSelectedMethods([]);
    }

    setIsAllSelected(isAll);
  };

  const getPaymentOptions = (): DropdownOption<PaymentOption>[] => {
    return PaymentOptionValues.map((value) => ({
      key: value,
      value,
      text: getPaymentOptionLabel(t, value),
    }));
  };

  return (
    <>
      <FormGroup style={{ marginLeft: '0', marginRight: '0' }}>
        <CardStyleRadioButton
          isSelected={isAllSelected}
          onClick={() => handleModeChange(true)}
          text={t(
            'providerAdmin.chargingPolicy.paymentOptionSelection.allPaymentOptionsButtonText',
            'All payment options (Charge Card, Scan to Pay, Tap to Pay)'
          )}
        />
        <CardStyleRadioButton
          isSelected={!isAllSelected}
          onClick={() => handleModeChange(false)}
          text={t(
            'providerAdmin.chargingPolicy.paymentOptionSelection.specificPaymentOptionsButtonText',
            'Specific payment options'
          )}
        />
      </FormGroup>
      {!isAllSelected && (
        <Form.Field required>
          <label>
            {t(
              'providerAdmin.chargingPolicy.paymentOptionSelection.selectPaymentOptionsLabel',
              'Select payment options'
            )}
          </label>
          <Dropdown
            selection
            multiple
            value={selectedMethods}
            options={getPaymentOptions()}
            onChange={(
              _: React.SyntheticEvent,
              { value }: { value: string[] }
            ) => setSelectedMethods(value)}
          />
        </Form.Field>
      )}
    </>
  );
};

export default PaymentOptionSelection;
